const initialState = {
  gameStrength: 4,
  playerLevel: 1,
};

export default initialState;